import React from 'react';

import Layout from '../layouts/LoginLayout';
import LoginForm from '../components/LoginForm';

const LoginPage = () => {
  return (
    <Layout>
      <LoginForm />
    </Layout>
  );
};

export default LoginPage;
